/**
 * Frontend version — bump on every feature/hotfix branch so atlas-tracked
 * deploys show the correct shipped version.
 */
export const VERSION = '1.54.6'; // prizes-v4-10-1 P1: admin video upload reflects MP4-only backend validation
